import "./hiring.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import {
  faYoutube,
  faFacebook,
  faSpotify,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";
import SectionWrapper from "../components/ComponentWrapper/SectionWrapper";
import BreathingBackground from "../components/BreathingBackground/BreathingBackground";

const Hiring = () => {
  const { t } = useTranslation();
  return (
    <BreathingBackground>
    <SectionWrapper>
    <main className="hiring-page">
      <section className="hiring-container">
        <header className="hiring-header">
          <h1>{t("hiring.title")}</h1>
          <p className="hiring-subtitle">{t("hiring.subtitle")}</p>
        </header>

        {/* CONTACTO */}
      <section className="epk-section contact">
        <h2>{t("epk.contactTitle", "Contact & booking")}</h2>

        <p>
          <strong>{t("epk.email", "Email")}:</strong>{" "}
          <a href="mailto:kujipy.suun@gmail.com" className="editorial-link">kujipy.suun@gmail.com</a>
        </p>

        <p>
          <strong>{t("epk.whatsapp", "WhatsApp")}:</strong>{" "}
          <a href="https://wa.me/522831169385" className="editorial-link" target="_blank" rel="noopener noreferrer">
            +52 283 116 9385
          </a>
        </p>

        <p>
          <strong>{t("epk.whatsapp", "WhatsApp")}:</strong>{" "}
          <a href="https://wa.me/522214418649" className="editorial-link" target="_blank" rel="noopener noreferrer">
            +52 221 441 8649
          </a>
        </p>

        <p>
          <strong>{t("common.website")}:</strong>{" "}
          <a href="https://www.kujipy.com" className="editorial-link" target="_blank" rel="noopener noreferrer">
            www.kujipy.com
          </a>
        </p>
      </section>

        <section className="hiring-social">
          <h3>{t("common.follow")}</h3>
          <div className="social-icons">
            <a href="https://www.youtube.com/@kujipyoficial8421" className="editorial-link"> 
              <FontAwesomeIcon icon={faYoutube} />
            </a>
            <a href="https://www.facebook.com/kujipy" className="editorial-link">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="https://open.spotify.com/intl-es/artist/3tDuuuTkPprgYHtL7QsvXs" className="editorial-link">
              <FontAwesomeIcon icon={faSpotify} />
            </a>
            <a href="https://www.instagram.com/kujipy" className="editorial-link">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
        </section>

        <footer className="hiring-note">
          <p>
            {t("hiring.epkNote")}{" "}
            <a href="/Kujipy_EPK_International.pdf" target="_blank" rel="noopener noreferrer">
              {t("common.downloadEpk")}
            </a>
          </p>
        </footer>
      </section>
    </main>
    </SectionWrapper>
    </BreathingBackground>
  );
};

export default Hiring;
